import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";

const BookingSuccess = () => {
  const { orderId } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const guestName = queryParams.get("guestName");
  const amount = queryParams.get("amount");

  return (
    <div className="container d-flex align-items-center justify-content-center ">
      <div
        className="card shadow-lg text-center p-4"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <div className="card-body">
          <div className="mb-4">
            <i
              className="bi bi-check-circle text-success"
              style={{ fontSize: "3rem" }}
            ></i>
          </div>
          <h2 className="card-title text-success">Booking Successful</h2>
          <p className="card-text fs-4">
            Thank you, your booking has been confirmed for the customer{" "}
            <strong style={{ color: "blueviolet" }}>{guestName}</strong>.
          </p>

          <ul className="list-group list-group-flush my-3">
            <li className="list-group-item fs-5">
              <strong>Order ID:</strong> {orderId}
            </li>
            <li className="list-group-item fs-4">
              <strong>Amount Paid:</strong> ₹{amount}
            </li>
          </ul>
          <div className="d-grid gap-2 mt-3">
            <Link to="/" className="btn btn-success">
              Go to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
